module.exports = __webpack_public_path__ + "assets/img/templatedownloadIcon.f9888287.png";